module.exports = __webpack_public_path__ + "static/kumite-hero-image-1fdb74c445b43c7afdf93ea00c4ae6c5.jpg";